<template>
  <sweet-modal ref="PandaConfigModal" width="40vw" :title="$t('ct-panda-video-config')">
    <div class="input-group mb-3 flex-column" v-if="videoConfigs && videoConfigs.video_player">
      <label for="pandavideo-chave-api">{{ $t('ct-panda-video-link-selected') }}</label>
      <a class="d-inline-block" :href="videoConfigs.video_player">{{ $t('ct-panda-video-link') }}</a>
    </div>
    <div class="input-group mb-3">

      <label
        for="pandavideo-chave-api"
        class="w-100">Chave API (
        <button class="btn btn-link p-0 m-0"
                onclick="window.open('https://dashboard.pandavideo.com.br/#/settings/advanced','_blank');">
          {{ $t('ct-panda-video-get-my-api-token') }}
        </button>
        )
      </label>
      <input
        type="text"
        class="form-control"
        id="pandavideo-chave-api"
        v-model="key_api"
      />
      <div class="input-group-append">
        <button
          class="btn btn-outline-secondary"
          type="button"
          @click="loadVideos()"
        >{{ $t('ct-panda-video-verify') }}
        </button>
      </div>
      <div class="invalid-feedback">{{ $t('ct-panda-video-invalid') }}</div>
      <div class="valid-feedback">{{ $t('ct-panda-video-valid') }}</div>
    </div>
    <template v-if="!loading">
      <template v-if="key_api && videos">
        <!-- Videos -->
        <div class="form-group mt-3 mb-3" v-if="videos && videos.length > 0">
          <label> {{ $t('ct-select-video-panda') }}</label>
          <select v-model="video_player_id" class="form-control">
            <option :value="null" disabled>{{ $t('ct-select-video-panda') }}</option>
            <option v-for="(video, index) in videos"
                    :key="index"
                    :value="video.id"
                    v-text="video.title"
            />
          </select>
        </div>

        <!-- None videos -->
        <div v-else-if="is_get">
          <p>{{ $t('ct-video-panda-have-create') }}</p>
        </div>
      </template>
      <alert-box-component class="mb-5">
        <p slot="content">
          {{ $t('ct-panda-video-security') }}
        </p>
      </alert-box-component>
    </template>
    <div class="text-center" v-else>
      <p>{{ $t('ct-loading') }}</p>
    </div>
    <!-- Buttons modal -->
    <a href="https://pandavideo.com.br/?ref=bapanda"
       target="_blank"
       class="btn btn-dark ml-0 float-left"
    >{{ $t('ct-panda-video-meet') }}
    </a>
    <div class="footer-buttons float-right">
      <button
        slot="button"
        class="btn btn-outline-light ml-0"
        @click="$refs.PandaConfigModal.close()"
      >{{ $t('ct-cancel') }}
      </button>

      <button
        v-if="videos && videos.length > 0"
        slot="button"
        class="btn btn-success"
        @click="save"
      ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
      </button>
    </div>
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';

import axios from "axios";
import AlertBoxComponent from "../../../commons/AlertBoxComponent.vue";

export default {
  name: 'PandaVideoModal',
  components: {
    AlertBoxComponent,
    SweetModal
  },
  data() {
    return {
      key_api: '',
      is_get: false,
      is_error: false,
      options: {},
      videoConfigs: {},
      video_player: null,
      video_player_id: null,
      showEvents: 0,
      videos: [],
      loading: false,
      success: false,
      callback: false
    };
  },
  watch: {
    'video_player_id' : function (val) {
      let videoPlayer = this.videos.find(video => video.id === val)
      this.selectVideo(videoPlayer)
    }
  },
  methods: {
    save() {
      this.callback({ videoConfigs: this.videoConfigs});
      this.$refs.PandaConfigModal.close();
      this.is_get = false;
      setTimeout(() => this.videoConfigs = {}, 200);
    },

    loadVideos() {
      this.is_error = false;
      this.loading = true;

      let url = 'https://api-v2.pandavideo.com.br/videos'
      axios.get(url, {
        headers: {
          'Accept': 'application/json',
          'Authorization': this.key_api
        }
      })
        .then(({data}) => {
          this.videos = data.videos;
        })
        .catch(() => {
          this.is_error = true;
        })
        .finally(() => {
          this.loading = false;
          this.is_get = true;
        })
    },

    selectVideo(video) {
      const { id, video_external_id, video_player, library_id, thumbnail} = video

      this.videoConfigs = {
        id: id,
        video_external_id: video_external_id,
        video_player: video_player,
        library_id: library_id,
        thumbnail: thumbnail
      }
    },

    init(config, callback = false) {
      this.options = config;
      this.video_player = config.videoConfigs;
      this.videoConfigs = config.videoConfigs;
      this.callback = callback;
    },
    open() {
      this.$refs.PandaConfigModal.open();
    }
  }
};
</script>
<style lang="scss" scoped>
h6 {
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 26px;
  height: 120px;

  a {
    margin-left: 10px;
  }
}

.form-group {
  .row {
    margin: 0;
  }
}

.footer-buttons {
  display: block;
  text-align: right;

  .btn {
    &:first-child {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/PandaVideo/ConfigModals.vue